import { Container, Modal } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import PrimaryButton, {
  SecondaryButton,
} from "../../../util/Btns/PrimaryButton";

import Close from "../../../Assets/close.svg";
import styles from "./ChangePassModal.module.scss";
import { PasswordInput } from "../../Input";
import { useState } from "react";
import TextError from "../../../util/formcomponents/TextError";
import { useChangePass } from "../../../hooks/DevAuthHooks";
import ConsoleLocalStorage from "../../../storage/storage";

const validationSchema = Yup.object().shape({
  // currentPass: Yup.string().required("Required"),
  newPass: Yup.string()
    .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{7,}$/i,"Minimum 8 characters, 1 lowercase, 1 uppercase, 1 numerical and 1 special character required.").required("Required"),
  confirmPass: Yup.string()
    .oneOf([Yup.ref("newPass"), null], "Passwords don't match!")
    .required("Required"),
});

const ChangePassModal = ({ showChangePass, setShowChangePass }) => {
  const handleClose = () => setShowChangePass(false);
  const [strength, setStrength] = useState("");

  const handlePasswordChange = (e) => {
    let password = e.target.value;
    if (password.length === 0) {
    } else if (password.length < 3) {
      setStrength({ msg: "Weak", class: "red" });
    } else if (password.length < 8) {
      setStrength({ msg: "Medium", class: "yellow" });
    } else if (password.length < 13) {
      setStrength({ msg: "Strong", class: "blue" });
    } else {
      setStrength({ msg: "Very Strong", class: "green" });
    }    
  };

  const initialValues = {
    currentPass: "",
    newPass: "",
    confirmPass: "",
  };

  const { mutate } = useChangePass(
    ConsoleLocalStorage.getUser().id,
    setShowChangePass
  );

  const onSubmit = (values) => {
    mutate({ newPassword: values.newPass });
  };
  return (
    <>
      <Container>
        <Modal
          show={showChangePass}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Change Password
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => setShowChangePass(false)}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      {/* <Field name="currentPass">
                        {({ form: { setFieldValue } }) => {
                          return (
                            <PasswordInput
                              required="true"
                              validate={true}
                              label="Current Password"
                              type="password"
                              warning={{}}
                              value={formik.values.currentPass}
                              onChange={(e) => {
                                // handlePasswordChange(e);
                                setFieldValue("currentPass", e.target.value);
                              }}
                              style={{ marginBottom: "00px" }}
                            />
                          );
                        }}
                      </Field> */}
                      <div style={{ marginTop: "-1.5rem" }}>
                        <ErrorMessage
                          component={TextError}
                          name={"currentPass"}
                        />
                      </div>
                      <Field name="newPass">
                        {({ form: { setFieldValue } }) => {
                          return (
                            <PasswordInput
                              required="true"
                              validate={true}
                              label="New Password"
                              type="password"
                              warning={strength}
                              value={formik.values.newPass}
                              onChange={(e) => {
                                handlePasswordChange(e);
                                setFieldValue("newPass", e.target.value);
                                formik.setFieldTouched('newPass');
                                formik.validateField('newPass');
                                formik.validateField('confirmPass');
                              }}
                              style={{ marginBottom: "-1.5em" }}
                            />
                          );
                        }}
                      </Field>

                      {/* <ErrorMessage component={TextError} name={"newPass"} /> */}
                      <Field name="confirmPass">
                        {({ form: { setFieldValue } }) => {
                          return (
                            <PasswordInput
                              required="true"
                              validate={true}
                              label="Confirm Password"
                              type="password"
                              warning={{}}
                              value={formik.values.confirmPass}
                              onChange={(e) => {
                                // handlePasswordChange(e);
                                formik.setFieldTouched('confirmPass');
                                setFieldValue("confirmPass", e.target.value);
                                formik.validateField('confirmPass');
                              }}
                              style={{ marginBottom: "00px" }}
                            />
                          );
                        }}
                      </Field>
                      <div
                        style={{
                          marginTop: "-1.5rem",
                          marginBottom: "1.5rem",
                        }}
                      >
                        <ErrorMessage
                          component={TextError}
                          name={"confirmPass"}
                        />
                      </div>
                      <div className={styles.buttonContainer}>
                        <SecondaryButton
                          onClick={() => setShowChangePass(false)}
                        >
                          Cancel
                        </SecondaryButton>
                        <PrimaryButton
                          onClick={() =>
                            setStrength({
                              msg: formik.errors.newPass,
                              class: "red",
                            })
                          }
                        >
                          Update
                        </PrimaryButton>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default ChangePassModal;
